import Footer from "../../components/shared/Footer";
import React, { useEffect, useState } from "react";
import SplittingUi from "../../components/shared/splitting/SplittingUi";
import { useLocation, useParams } from "react-router-dom";
import qs from "qs";
import { QueueService } from "../../services/SubmissionService";
import * as APIModels from "../../models";

export default function Splitter() {
    // use react router to get the path variables

    const { s3loc } = useParams<{ s3loc?: string }>();
    const { filename } = useParams<{ filename?: string }>();

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Splitting</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Split File
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <SplittingUi
                                {...{
                                    s3loc: s3loc ?? "",
                                    filename: filename ?? "",
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
